
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkLedgerModeEnum } from '../models/work-ledger-mode-enum';
import { requiredBoolean } from './required-boolean.validator';
import { WorkAccountSelectionModeEnum } from '../models/work-account-selection-mode-enum';

export function getAccountingSettingsFormGroup() {
return new FormGroup({
    id: new FormControl<number | undefined>(undefined, [Validators.required]),
    created: new FormControl<string | undefined>(undefined),
    modified: new FormControl<string | undefined>(undefined),
    ledgerMode: new FormControl<WorkLedgerModeEnum | undefined>(undefined, [Validators.required]),
    exportConnectorKey: new FormControl<string | undefined>(undefined),
    testMode: new FormControl<boolean | undefined>(undefined, [requiredBoolean()]),
    ownCompanyNames: new FormControl<Array<string> | undefined>([]),
    payablesControlAccountId: new FormControl<number | undefined>(undefined),
    accountSelectionMode: new FormControl<WorkAccountSelectionModeEnum | undefined>(undefined, [Validators.required]),
    creditNoteCode: new FormControl<string | undefined>('', [Validators.required]),
    invoiceCode: new FormControl<string | undefined>('', [Validators.required]),
    attachPdf: new FormControl<boolean | undefined>(undefined, [requiredBoolean()]),
    bookOnApproval: new FormControl<boolean | undefined>(undefined, [requiredBoolean()]),
    legacyExpenseAccountId: new FormControl<number | undefined>(undefined),
    modifiedBy: new FormControl<number | undefined>(undefined),
})
;
}
      